import { render } from "./Pustaka.vue?vue&type=template&id=5461ca1e"
import script from "./Pustaka.vue?vue&type=script&lang=js"
export * from "./Pustaka.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__